import { Datatype } from '../../../../datatype/Datatype';
import { createConditionOperator } from '../../IConditionOperator';

/**
 * Versione di "defined" per i campi array.
 */
export const ConditionOperatorNotEmptyItemType = createConditionOperator({
  code: 'notEmptyItem',
  label: 'non è vuoto',
  description: 'Non è vuoto',
  args: [],
  allowsField: field => field.type === Datatype.Array,
  compare(value: any) {
    if (!value) return false;
    return Array.isArray(value) && value.length > 0;
  },
});
